"use strict";
exports.__esModule = true;
exports.useFundFirstPaymentRoute = exports.getOfferByBillerAccountRoute = exports.getScheduleOptionsRoute = exports.updateEmailRoute = exports.getBillerPropertyUnitsRoute = exports.getBillerPropertyPortalDetailsRoute = exports.locationSuggestRoute = exports.oonSelfPayVirtualCardRoute = exports.oonPayDownpaymentRoute = exports.oonSelfPayStartRoute = exports.getBillerPropertyDetailsRoute = exports.unpauseAutopayRoute = exports.pauseAutopayRoute = exports.cancelAccountRoute = exports.useAcceptOfferRoute = exports.useRestartOnboardingRoute = exports.useRegisterActionLogRoute = exports.useGetOnboardingStatusRoute = exports.retryDownpaymentRoute = exports.useIdentityMatchStatusRoute = exports.useCustomerIdentityRoute = exports.updateOfferTermsRoute = exports.propertySearchRoute = exports.getPricingOfferRoute = exports.useSetOfferScheduleRoute = exports.useEvaluateOfferRoute = exports.useInitiateOfferRoute = exports.chargeOutstandingBalanceRoute = exports.evaluateOutstandingBalanceRoute = exports.chargeRepaymentRoute = exports.acceptOfferRelinkRoute = exports.unpauseBillerAccountRoute = exports.pauseBillerAccountRoute = exports.updateBillerRoute = exports.createOverwritePaymentScheduleRoute = exports.confirmOverwritePaymentScheduleRoute = exports.getStatusRoute = exports.getRentAmountUpdateSurveyRoute = exports.cancelPaymentRoute = exports.useVirtualCardRoute = exports.useDdaRoute = exports.setupCardRoute = exports.cancelCardSetupRoute = exports.addCardRoute = exports.getFeatureStatusRoute = void 0;
var baseUrl = 'v1/orchestration';
var basePublicUrl = 'v1/orchestration/public';
var getFeatureStatusRoute = function (customerPublicId) { return "".concat(baseUrl, "/").concat(customerPublicId, "/features"); };
exports.getFeatureStatusRoute = getFeatureStatusRoute;
// Wallet
var addCardRoute = function (customerPublicId, stripePaymentMethodId) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/card?stripe_payment_method_id=").concat(stripePaymentMethodId);
};
exports.addCardRoute = addCardRoute;
var cancelCardSetupRoute = function (customerPublicId, stripeSetupIntentId) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/card/setup?stripe_setup_intent_id=").concat(stripeSetupIntentId);
};
exports.cancelCardSetupRoute = cancelCardSetupRoute;
var setupCardRoute = function (customerPublicId, stripePaymentMethodId) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/card/setup?stripe_payment_method_id=").concat(stripePaymentMethodId);
};
exports.setupCardRoute = setupCardRoute;
// Get DDA Account Info
var useDdaRoute = function (customerPublicId, billTransactionId, firstCall) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billTransactionId, "/dda?first_call=").concat(firstCall);
};
exports.useDdaRoute = useDdaRoute;
// Get Virtual Card Info
var useVirtualCardRoute = function (customerPublicId, billTransactionId, firstCall) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billTransactionId, "/vc?first_call=").concat(firstCall);
};
exports.useVirtualCardRoute = useVirtualCardRoute;
// Cancel Payment for Self Pay
var cancelPaymentRoute = function (customerPublicId, billerAccountPublicId, billTransactionId) { return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billerAccountPublicId, "/").concat(billTransactionId, "/cancel"); };
exports.cancelPaymentRoute = cancelPaymentRoute;
// Get BTH Survey Choices
exports.getRentAmountUpdateSurveyRoute = "".concat(baseUrl, "/survey/rent_amount_update");
// Get Status
var getStatusRoute = function (customerPublicId, billerAccountPublicId, queryDate) {
    return "".concat(baseUrl, "/status/").concat(customerPublicId, "/").concat(billerAccountPublicId, "?query_date=").concat(queryDate);
};
exports.getStatusRoute = getStatusRoute;
// Overwrite (BTH/BTL)
var confirmOverwritePaymentScheduleRoute = function (customerPublicId, billerAccountPublicId, billTransactionId, overwritePublicId) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billerAccountPublicId, "/").concat(billTransactionId, "/overwrite/").concat(overwritePublicId);
};
exports.confirmOverwritePaymentScheduleRoute = confirmOverwritePaymentScheduleRoute;
var createOverwritePaymentScheduleRoute = function (customerPublicId, billerAccountPublicId, billTransactionId) { return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billerAccountPublicId, "/").concat(billTransactionId, "/overwrite"); };
exports.createOverwritePaymentScheduleRoute = createOverwritePaymentScheduleRoute;
// Relink
var updateBillerRoute = function (customerPublicId, billerAccountPublicId) {
    return "".concat(baseUrl, "/biller/").concat(customerPublicId, "/").concat(billerAccountPublicId);
};
exports.updateBillerRoute = updateBillerRoute;
// Pause & Resume
var pauseBillerAccountRoute = function (customerPublicId, billerPublicId) {
    return "".concat(baseUrl, "/status/product-state/").concat(billerPublicId, "/pause?customer_public_id=").concat(customerPublicId);
};
exports.pauseBillerAccountRoute = pauseBillerAccountRoute;
var unpauseBillerAccountRoute = function (customerPublicId, billerPublicId) {
    return "".concat(baseUrl, "/status/product-state/").concat(billerPublicId, "/unpause?customer_public_id=").concat(customerPublicId);
};
exports.unpauseBillerAccountRoute = unpauseBillerAccountRoute;
// Accept Offer
var acceptOfferRelinkRoute = function (customerPublicId, billerAccountPublicId, offerId) { return "".concat(baseUrl, "/relink/").concat(customerPublicId, "/").concat(billerAccountPublicId, "/").concat(offerId, "/accept"); };
exports.acceptOfferRelinkRoute = acceptOfferRelinkRoute;
// Repay Now
var chargeRepaymentRoute = function (customerPublicId, userPaymentPublicId) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(userPaymentPublicId, "/charge");
};
exports.chargeRepaymentRoute = chargeRepaymentRoute;
// Repay Now DQ
var evaluateOutstandingBalanceRoute = function (customerPublicId, billerAccountPublicId) {
    return "".concat(baseUrl, "/payment/").concat(customerPublicId, "/balance?biller_account_public_id=").concat(billerAccountPublicId);
};
exports.evaluateOutstandingBalanceRoute = evaluateOutstandingBalanceRoute;
var chargeOutstandingBalanceRoute = function (customerPublicId, billTransactionId, baseAmount) {
    return "".concat(baseUrl, "/payment/").concat(customerPublicId, "/balance?bill_transaction_id=").concat(billTransactionId, "&base_amount=").concat(baseAmount);
};
exports.chargeOutstandingBalanceRoute = chargeOutstandingBalanceRoute;
// Offers
var useInitiateOfferRoute = function (customerPublicId) {
    return "".concat(baseUrl, "/offers/").concat(customerPublicId, "/initiate-offer");
};
exports.useInitiateOfferRoute = useInitiateOfferRoute;
var useEvaluateOfferRoute = function (customerPublicId) {
    return "".concat(baseUrl, "/offers/").concat(customerPublicId, "/evaluate-offer");
};
exports.useEvaluateOfferRoute = useEvaluateOfferRoute;
var useSetOfferScheduleRoute = function (customerPublicId, offerId) {
    return "".concat(baseUrl, "/offers/").concat(customerPublicId, "/").concat(offerId, "/set-schedule");
};
exports.useSetOfferScheduleRoute = useSetOfferScheduleRoute;
// Pricing
var getPricingOfferRoute = function (billerAccountPublicId) {
    return "".concat(baseUrl, "/pricing/").concat(billerAccountPublicId, "/fees");
};
exports.getPricingOfferRoute = getPricingOfferRoute;
// Property Search
var propertySearchRoute = function (searchQuery) { return "".concat(baseUrl, "/properties/search?").concat(searchQuery); };
exports.propertySearchRoute = propertySearchRoute;
// Update Offer Terms
var updateOfferTermsRoute = function (customerPublicId, offerId) {
    return "".concat(baseUrl, "/offers/").concat(customerPublicId, "/").concat(offerId, "/update");
};
exports.updateOfferTermsRoute = updateOfferTermsRoute;
// Identity
var useCustomerIdentityRoute = function (customerPublicId) {
    return "/".concat(basePublicUrl, "/customers/").concat(customerPublicId, "/accounts");
};
exports.useCustomerIdentityRoute = useCustomerIdentityRoute;
var useIdentityMatchStatusRoute = function (customerPublicId) {
    return "/".concat(basePublicUrl, "/customers/").concat(customerPublicId, "/accounts/match/status");
};
exports.useIdentityMatchStatusRoute = useIdentityMatchStatusRoute;
// Retry Downpayment
var retryDownpaymentRoute = function (customerPublicId, billTransactionId) {
    return "/".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billTransactionId, "/auth");
};
exports.retryDownpaymentRoute = retryDownpaymentRoute;
// Onboarding
var useGetOnboardingStatusRoute = function (customerPublicId, variantId) {
    return "/".concat(baseUrl, "/").concat(customerPublicId, "/onboarding/status?variant_id=").concat(variantId || 'control');
};
exports.useGetOnboardingStatusRoute = useGetOnboardingStatusRoute;
// This is a temporal solution to action log not allowing inserting records without a customer_id
var useRegisterActionLogRoute = function (customerPublicId) {
    return "/".concat(baseUrl, "/").concat(customerPublicId, "/onboarding/log-action");
};
exports.useRegisterActionLogRoute = useRegisterActionLogRoute;
var useRestartOnboardingRoute = function (customerPublicId) {
    return "/".concat(baseUrl, "/").concat(customerPublicId, "/onboarding/restart");
};
exports.useRestartOnboardingRoute = useRestartOnboardingRoute;
var useAcceptOfferRoute = function (customerPublicId, offerId) {
    return "".concat(baseUrl, "/offers/").concat(customerPublicId, "/").concat(offerId, "/accept");
};
exports.useAcceptOfferRoute = useAcceptOfferRoute;
// Cancel 2.0
var cancelAccountRoute = function (customerPublicId, billerAccountPublicId) {
    return "".concat(baseUrl, "/customer/").concat(customerPublicId, "/account/").concat(billerAccountPublicId, "/cancel");
};
exports.cancelAccountRoute = cancelAccountRoute;
// Pause & Resume 2.0
var pauseAutopayRoute = function (customerPublicId, billerAccountPublicId) {
    return "".concat(baseUrl, "/customer/").concat(customerPublicId, "/account/").concat(billerAccountPublicId, "/pause");
};
exports.pauseAutopayRoute = pauseAutopayRoute;
var unpauseAutopayRoute = function (customerPublicId, billerAccountPublicId) {
    return "".concat(baseUrl, "/customer/").concat(customerPublicId, "/account/").concat(billerAccountPublicId, "/unpause");
};
exports.unpauseAutopayRoute = unpauseAutopayRoute;
// Biller Property
var getBillerPropertyDetailsRoute = function (propertyId) { return "".concat(baseUrl, "/properties/").concat(propertyId); };
exports.getBillerPropertyDetailsRoute = getBillerPropertyDetailsRoute;
// Out of Network Self Pay Start
var oonSelfPayStartRoute = function (customerPublicId, billerAccountPublicId, billTransactionId) { return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billerAccountPublicId, "/").concat(billTransactionId, "/oon/self-pay-start"); };
exports.oonSelfPayStartRoute = oonSelfPayStartRoute;
// OON Self Pay Downpayment
var oonPayDownpaymentRoute = function (customerPublicId, billerAccountPublicId, billTransactionId, oonSelfPayStartPublicId) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billerAccountPublicId, "/").concat(billTransactionId, "/oon/").concat(oonSelfPayStartPublicId, "/downpayment");
};
exports.oonPayDownpaymentRoute = oonPayDownpaymentRoute;
// OON Self Pay Virtual Card
var oonSelfPayVirtualCardRoute = function (customerPublicId, billerAccountPublicId, billTransactionId) { return "".concat(baseUrl, "/").concat(customerPublicId, "/").concat(billerAccountPublicId, "/").concat(billTransactionId, "/oon/vc"); };
exports.oonSelfPayVirtualCardRoute = oonSelfPayVirtualCardRoute;
// Location Suggest
var locationSuggestRoute = function (address_line_1, address_line_2, city, state, zip) {
    return "".concat(baseUrl, "/location/suggest?address_line_1=").concat(encodeURIComponent(address_line_1), "&address_line_2=").concat(encodeURIComponent(address_line_2), "&city=").concat(encodeURIComponent(city), "&state=").concat(encodeURIComponent(state), "&zip=").concat(encodeURIComponent(zip));
};
exports.locationSuggestRoute = locationSuggestRoute;
var getBillerPropertyPortalDetailsRoute = function (propertyId) {
    return "".concat(baseUrl, "/properties/").concat(propertyId, "/portal");
};
exports.getBillerPropertyPortalDetailsRoute = getBillerPropertyPortalDetailsRoute;
var getBillerPropertyUnitsRoute = function (propertyId) { return "".concat(baseUrl, "/properties/").concat(propertyId, "/units"); };
exports.getBillerPropertyUnitsRoute = getBillerPropertyUnitsRoute;
// Update Email
var updateEmailRoute = function (customerPublicId) { return "".concat(baseUrl, "/").concat(customerPublicId, "/account/email"); };
exports.updateEmailRoute = updateEmailRoute;
var getScheduleOptionsRoute = function (customerPublicId, offerId) {
    return "".concat(baseUrl, "/offers/").concat(customerPublicId, "/").concat(offerId, "/set-schedule");
};
exports.getScheduleOptionsRoute = getScheduleOptionsRoute;
var getOfferByBillerAccountRoute = function (customerPublicId, billerAccountPublicId) {
    return "".concat(baseUrl, "/offers/").concat(customerPublicId, "/find-by-biller-account/").concat(billerAccountPublicId);
};
exports.getOfferByBillerAccountRoute = getOfferByBillerAccountRoute;
var useFundFirstPaymentRoute = function (customerPublicId) {
    return "".concat(baseUrl, "/").concat(customerPublicId, "/bill/prepay");
};
exports.useFundFirstPaymentRoute = useFundFirstPaymentRoute;
